import { makeOnceFlag } from './onceFlag';

// One-shot flag behind TM-10: has this athlete ever stopped a running hold or
// cardio timer by tapping the effort band?
//
// Until they have, a caption pulses on the band while a timer runs, saying that
// a tap stops it and logs the set. It PULSES rather than sitting there (fixed
// 2026-07-22): held static it covered the band's middle stops permanently and
// took their numbers to 1.17:1, so the ramp read by colour alone in the one
// state where a stop has to be picked. The gesture is new with MX-5 slice 3 and
// the screen says nothing about it otherwise: the slot's word is deliberately
// styled as NOT a button, and the spoken hint reaches screen-reader users only.
// The cost of not knowing isn't hesitation, it's pressing the ✕ — the only
// control on that row that plainly reads "end this" — which throws the held
// seconds away.
//
// Marked on the first successful capture, not on the first sighting: the point
// is that the athlete has DONE it once, not that a caption was on screen while
// they looked elsewhere.
const flag = makeOnceFlag('jackedlogs.holdBandStop.v1.done');

// The read path is the hook (useOnceFlag) in the component that shows the
// caption; only the mark has a caller of its own, in the effort commit.
export const markBandStopSeen = (): Promise<void> => flag.mark();
export const bandStopFlag = flag;
